import { effectiveHeadingLevel } from '@ctw/shared/components/heading';
import { uniqueIdentifierForNode } from '@ctw/shared/content/document-viewer/_internal/renderers/helpers';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import type { CdaSection } from '../../parsers/types';
import { PdfNodeRenderer } from './pdf-node-renderer';

export const styles = StyleSheet.create({
  container: {
    fontFamily: 'Inter',
    flexDirection: 'column',
    width: '100%',
    marginBottom: 10,
  },
  h1: {
    fontFamily: 'Inter',
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 5,
  },
  h2: {
    fontFamily: 'Inter',
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 5,
  },
  h3: {
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 5,
  },
  h4: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 5,
  },
  h5: {
    fontFamily: 'Inter',
    fontSize: 12,
    fontWeight: 600,
    marginBottom: 5,
  },
  h6: {
    fontFamily: 'Inter',
    fontSize: 10,
    fontWeight: 600,
    marginBottom: 5,
  },
});

interface PdfHeadingRendererProps {
  section: CdaSection;
  heading: HTMLElement;
}

export const PdfHeadingRenderer = ({ section, heading }: PdfHeadingRendererProps) => {
  const level = effectiveHeadingLevel(heading.nodeName);
  const style = styles[level as keyof typeof styles];

  return (
    <View style={styles.container}>
      <Text style={style}>
        {Array.from(heading.childNodes).map((child) => (
          <PdfNodeRenderer
            key={uniqueIdentifierForNode({ section, node: child, context: 'node-heading-child' })}
            node={child}
            section={section}
          />
        ))}
      </Text>
    </View>
  );
};
